window.Offerings = {}